import EnrollmentApplicationModal from 'Agent/Accounts/components/EnrollmentApplication/EnrollmentApplicationModal';
import RequestPolicyInfoReportModal from 'Agent/Accounts/components/RequestPolicyInfoReportModal';
import ClaimsConfirmationModal from 'Agent/Policies/components/ClaimsConfirmationModal';
import DeleteBeneficiaryConfirmationModal from 'Beneficiaries/components/DeleteBeneficiaryConfirmationModal';
import AlertsModal from 'Core/components/Alerts/AlertsModal';
import LegacyAccessModal from 'Core/components/Navigation/LegacyAccessModal';
import LegacySignOn from 'Core/components/Navigation/LegacySignOn';
import ShareLink from 'Core/components/ShareLink/ShareLink';
import {hideModal, ModalState, ModalStateUnion} from 'Core/ducks/modal';
import EnrollmentApplicationDeleteConfirmationModal from 'Enrollment/components/EnrollmentFileProcessing/EnrollmentApplicationDeleteConfirmationModal';
import EnrollmentFileRejectsEmail from 'Enrollment/components/EnrollmentFileProcessing/EnrollmentFileRejectsEmail';
import EnrollmentFilesNotProcessedNotesModal from 'Enrollment/components/EnrollmentFilesNotProcessed/EnrollmentFilesNotProcessedNotesModal';
import ExternalUploadQueueCancelConfirmationModal from 'Enrollment/components/UploadEnrollmentApplications/ExternalUploadQueueCancelConfirmationModal';
import ExternalUploadReturnToBrokerModel from 'Enrollment/components/UploadEnrollmentApplications/ExternalUploadReturnToBrokerModel';
import UserDetailsModal from 'Enrollment/components/UploadEnrollmentApplications/UserDetailsModal';
import ExternalUploadQueueProcessConfirmationModal from 'Enrollment/components/UploadEnrollmentApplications/ExternalUploadQueueProcessConfirmationModal';
import GenelcoApplicationsModal from 'Enrollment/components/UploadEnrollmentApplications/GenelcoApplicationsModal';
import BrokerSpreadsheetCancelConfirmationModal from 'Enrollment/components/UploadEnrollmentApplications/BrokerSpreadsheetCancelConfirmationModal';
import UploadEnrollmentApplicationModal from 'Enrollment/components/UploadEnrollmentApplications/UploadEnrollmentApplicationModal';
import React from 'react';
import {connect} from 'react-redux';
import {ReducerState} from 'rootReducer';
import FilterResultsDialog from 'Shared/components/FilterResultsDialog';
import AgentManualEntry from 'Users/components/AgentAdministration/AgentManualEntry';
import OffboardingConfirmation from 'Users/components/AgentAdministration/OffboardingConfirmation';
import SSOConfirmationModal from 'Users/components/SingleSignOn/SSOConfirmationModal';
import SwitchTaxIdModal from 'Users/components/UserAccount/SwitchTaxIdModal';
import DeletePendingRegistrationConfirmationModal from 'Users/components/UserAdministration/DeletePendingRegistrationConfirmationModal';
import Registration from 'Users/components/UserAdministration/Registration';
import ReviewSecurityQuestionsAndResetPasswordModal from 'Users/components/UserProfile/ReviewSecurityQuestionsAndResetPasswordModal';
import SimplifiedEnrollmentFileUploadCancelConfirmationModal from 'Enrollment/components/UploadEnrollmentApplications/SimplifiedEnrollmentFileUploadCancelConfirmationModal';
import {UserClaims} from 'Users/models/Claims';
import ClientOnboardingMaintenanceModal from 'Enrollment/components/ClientOnboardingProfiles/ClientOnboardingMaintenanceModal';
import GenelcoUploadInternalSystemErrorModal from 'Enrollment/components/UploadEnrollmentApplications/GenelcoUploadInternalSystemErrorModal';
import VerifyCriticalInformationModal from 'ApplicationEntry/components/WorkFlow/VerifyCriticalInformation/VerifyCriticalInformationModal';
import ExternalUploadQueueAdditionalDetailsModal from 'Enrollment/components/UploadEnrollmentApplications/ExternalUploadQueueAdditionalDetailsModal';

type ModalConductorProps = {
  hideModal: typeof hideModal;
  modalState: ModalStateUnion;
};

export const ModalConductor = (props: ModalConductorProps) => {
  return ModalState.match(props.modalState, {
    AddAgent: () => <AgentManualEntry />,
    Alerts: alertData => (
      <AlertsModal
        hideModal={() => {
          props.hideModal();
          alertData.onDismissAlerts();
        }}
        alerts={alertData.messages}
      />
    ),
    UploadEnrollmentApplication: enrollmentApplicationData => (
      <EnrollmentApplicationModal
        accountId={enrollmentApplicationData.accountId}
        accountNumber={enrollmentApplicationData.accountNumber}
        servicingAgentNumber={enrollmentApplicationData.servicingAgentNumber}
        hideModal={props.hideModal}
      />
    ),
    UsersRegistration: userRegistrationData => (
      <Registration
        onClose={() => {
          userRegistrationData.onClose();
          props.hideModal();
        }}
      />
    ),
    LegacySignOn: () => (
      <LegacySignOn
        onLogin={() => {
          window.open('https://access.allstatebenefits.com/');
        }}
        onClose={props.hideModal}
      />
    ),
    None: () => null,
    OffboardingConfirmation: offboardingData => (
      <OffboardingConfirmation onClose={props.hideModal} agent={offboardingData.agent} />
    ),
    RequestPolicyInfoReport: requestReportProps => (
      <RequestPolicyInfoReportModal
        onClose={props.hideModal}
        accountDetail={requestReportProps.accountDetail}
        userClaims={requestReportProps.userClaims}
        email={requestReportProps.email}
      />
    ),
    ShareLink: () => <ShareLink onClose={props.hideModal} />,
    EnrollmentFileRejectsEmail: modalState => (
      <EnrollmentFileRejectsEmail
        isResend={modalState.isResend}
        emailId={modalState.emailId}
        groupId={modalState.groupId}
        onClose={props.hideModal}
      />
    ),
    SwitchTaxId: stateModal => (
      <SwitchTaxIdModal agencyAssociations={stateModal.agencyAssociations} onClose={props.hideModal} />
    ),

    MobileFilter: mobileFilter => <FilterResultsDialog onClose={props.hideModal} {...mobileFilter} />,
    ClaimsConfirmation: claimsConfirmationModalState => (
      <ClaimsConfirmationModal policyNumber={claimsConfirmationModalState.policyNumber} onClose={props.hideModal} />
    ),
    LegacyAccess: () => <LegacyAccessModal />,
    DeleteBeneficiaryConfirmation: modalState => (
      <DeleteBeneficiaryConfirmationModal
        onClose={props.hideModal}
        policyNumber={modalState.policyNumber}
        id={modalState.id}
      />
    ),
    EnrollmentFilesNotProcessedNotes: modalState => (
      <EnrollmentFilesNotProcessedNotesModal onClose={props.hideModal} notes={modalState.notes} />
    ),
    EnrollmentApplicationUpload: modalState => (
      <UploadEnrollmentApplicationModal
        onClose={props.hideModal}
        fileId={modalState.fileId}
        groupId={modalState.groupId}
      />
    ),
    ClientOnboardingUpload: () => <ClientOnboardingMaintenanceModal onClose={props.hideModal} />,
    EnrollmentFileErrorDeleteConfirmation: enrollmentErrorModalState => (
      <EnrollmentApplicationDeleteConfirmationModal
        caseRequestId={enrollmentErrorModalState.caseRequestId}
        onClose={props.hideModal}
      />
    ),
    ExternalUploadQueueRemoveConfirmation: externalUploadQueueModalState => (
      <ExternalUploadQueueCancelConfirmationModal
        fileId={externalUploadQueueModalState.fileId}
        uploadedByEmail={externalUploadQueueModalState.uploadedByEmail}
        onClose={props.hideModal}
      />
    ),
    ExternalUploadReturnToBroker: externalUploadReturnToBrokerState => (
      <ExternalUploadReturnToBrokerModel
        onClose={props.hideModal}
        removalReason={externalUploadReturnToBrokerState.removalReason}
        returnComments={externalUploadReturnToBrokerState.returnComments}
        recentActionDate={externalUploadReturnToBrokerState.recentActionDate}
      />
    ),
    UserDetails: userDetailsState => (
      <UserDetailsModal
        onClose={props.hideModal}
        firstName={userDetailsState.firstName}
        lastName={userDetailsState.lastName}
        email={userDetailsState.email}
      />
    ),
    ExternalUploadQueueProcessConfirmation: externalUploadQueueModalState => (
      <ExternalUploadQueueProcessConfirmationModal
        fileId={externalUploadQueueModalState.fileId}
        onClose={props.hideModal}
      />
    ),
    BrokerSpreadSheetCancelConfirmation: externalUploadQueueModalState => (
      <BrokerSpreadsheetCancelConfirmationModal
        fileId={externalUploadQueueModalState.fileId}
        onClose={props.hideModal}
      />
    ),
    DeletePendingRegistrationConfirmation: modalState => (
      <DeletePendingRegistrationConfirmationModal
        onClose={props.hideModal}
        id={modalState.id}
        filter={modalState.filter}
        encryptedIdentifier={modalState.encryptedIdentifier}
      />
    ),
    SSOConfirmation: () => <SSOConfirmationModal />,
    ReviewSecurityQuestionsAndResetPassword: (userClaims: UserClaims) => (
      <ReviewSecurityQuestionsAndResetPasswordModal userClaims={userClaims} />
    ),
    GenelcoEnrollmentApplications: genelcoApplications => (
      <GenelcoApplicationsModal close={props.hideModal} enrollmentFile={genelcoApplications.enrollmentFile} />
    ),
    SimplifiedEnrollmentFileUploadCancelConfirmation: UploadEnrollmentFileModalState => (
      <SimplifiedEnrollmentFileUploadCancelConfirmationModal
        fileId={UploadEnrollmentFileModalState.fileId}
        onClose={props.hideModal}
      />
    ),
    GenelcoUploadInternalSystemError: () => <GenelcoUploadInternalSystemErrorModal onClose={props.hideModal} />,
    VerifyCriticalInformation: verifyCriticalInformationData => (
      <VerifyCriticalInformationModal
        application={verifyCriticalInformationData.application}
        hideModal={props.hideModal}
      />
    ),
    ExternalUploadQueueAdditionalDetails: externalUploadQueueAdditionalDetailsState => (
      <ExternalUploadQueueAdditionalDetailsModal
        onClose={props.hideModal}
        reason={externalUploadQueueAdditionalDetailsState.reason!}
        reasonType={externalUploadQueueAdditionalDetailsState.reasonType}
        returnComments={externalUploadQueueAdditionalDetailsState.returnComments!}
      />
    ),
  });
};

export const mapStateToProps = (state: ReducerState) => ({
  modalState: state.modal.modalState,
});

export default connect(mapStateToProps, {
  hideModal,
})(ModalConductor);
